import {api} from "./api";

export const createBriefing = async (idAttendance : string) => {
    return api.post(`/briefing/create/${idAttendance}`)
}

const briefingApi = {
    createBriefing
}

export default briefingApi;